import cx from "classnames";

import styles from "./PaymentConstrainedWidth.module.scss";

interface PaymentConstrainedWidthProps {
  children: React.ReactNode;
  className?: string;
}

const PaymentConstrainedWidth = ({
  children,
  className,
}: PaymentConstrainedWidthProps) => {
  return <div className={cx(styles.container, className)}>{children}</div>;
};

export default PaymentConstrainedWidth;
